export enum JobStatus {
	NotStarted = 1,
	InProgress = 2,
	Completed = 3,
	Cancelled = 4,
	CompletedAndStored = 5,
	Archived = 6,
	ReadyForArchiving = 7,
	StorageMismatch = 8
}
